import { Controller } from '@hotwired/stimulus';

export default class ProgressController extends Controller {
  static targets = ['circleProgress', 'circleProgressPercentage'];

  connect() {
    this.element.addEventListener(
      'signature:progress-update',
      this.handleProgressUpdate.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      'signature:progress-update',
      this.handleProgressUpdate.bind(this)
    );
  }

  handleProgressUpdate(event) {
    const { percentage } = event.detail;
    this.updateProgress(percentage);
  }

  updateProgress(percentage) {
    if (
      !this.hasCircleProgressTarget ||
      !this.hasCircleProgressPercentageTarget
    ) {
      return;
    }

    const progressClasses = [
      'progress--0',
      'progress--25',
      'progress--50',
      'progress--75',
      'progress--100',
    ];
    progressClasses.forEach((className) => {
      this.circleProgressTarget.classList.remove(className);
    });

    this.circleProgressTarget.classList.add(`progress--${percentage}`);

    this.circleProgressPercentageTarget.textContent = `${percentage}%`;
  }
}
